export default __webpack_public_path__ + "static/media/set-short-1.743bb38e.png";